import '../scss/sg1.scss'
import { accessibility } from './modules/accessibility.js'
import { SG1Logs } from './modules/logs.js'
import { isForcedProd, isObject } from './modules/utilities.js'
import { orchestrator } from './orchestrator.js'
import { config } from './config.js'

const SSEConnection = () => {
   let SSE = null
   let path = window.dataStoreHP.SSEpath
   let mockPath = 'hp-regulier.json'

   // Mocks SSE
   if (process.env.NODE_ENV === 'development') {
      if (!isForcedProd()) {
         const { MockEvent, EventSource: EventSourceMock } = require('mocksse')
         EventSource = EventSourceMock
         let mockFile = require('../mocks/' + mockPath)
         new MockEvent(mockFile)
      }
   }

   // Connexion SSE
   if (typeof window.dataStoreHP.jwt !== 'undefined' && typeof window.dataStoreHP.requestId !== 'undefined') {
      let qs = window.location.search === '' ? '?' : window.location.search + '&'
      qs = qs + 'jwt=' + window.dataStoreHP.jwt + '&requestId=' + window.dataStoreHP.requestId

      if (window.location.hostname.indexOf('boutique.orange.fr') !== -1) {
         SSE = new EventSource('https://www.orange.fr/' + path + qs, { withCredentials: true })
      } else {
         if (process.env.NODE_ENV === 'development') {
            if (!isForcedProd()) {
               SSE = new EventSource('/' + path)
            } else {
               SSE = new EventSource('/' + path + qs)
            }
         } else {
            SSE = new EventSource('/' + path + qs)
         }
      }

      window.dataStoreHP.SSEstatus = 'connected'
   }

   return SSE
}

// MAIN ================================
try {

   // SG1updateComponent pour les ABTest
   window.SG1updateComponent = (eventId = '', data = {}) => {
      if (isObject(data) && eventId !== '' && config[eventId] !== undefined && config[eventId].state !== undefined) {
         if (window.dataStoreHP.SSEstatus === 'disconnected') {
            // si on execute la fonction a la fin de la connexion SSE
            config[eventId].state.value = data
         } else {
            // si on execute la fonction avant la connexion SSE on attend l'évent de fin de transmission
            document.addEventListener('sseEndOfTransmition', () => {
               config[eventId].state.value = data
            })
         }
      } else {
         console.error('SG1updateComponent: eventId ou data non défini')
      }
   }

   SG1Logs.init()

   let SSE = SSEConnection()

   let SSEResponseTime = new Date().getTime()

   if (SSE !== null) {
      SSE.addEventListener('renderEvent', (event) => {
         try {
            let data = event.data
            if (process.env.NODE_ENV === 'production') {
               // condition webpack de COMPILATION pas de run coté client
               data = JSON.parse(data)
            } else {
               if (isForcedProd()) {
                  data = JSON.parse(data)
               }
            }

            orchestrator(data, config)

         } catch (error) {
            console.error('Catch error: SSE renderEvent', { error: error, event: event })
         }
      })

      // SSE Rendering Error
      SSE.addEventListener('error', (event) => {
         console.error('SSE connexion error', event)
      })

      // SSE EndOfTransmission
      SSE.addEventListener('EOT', (event) => {
         let eotEvent = new CustomEvent(`sseEndOfTransmition`, {
            detail: {
               eot: true,
               responseTime: new Date().getTime() - SSEResponseTime,
            },
         })
         document.dispatchEvent(eotEvent)

         setTimeout(() => {
            window.prerenderReady = true // pour prerender.io
         }, 10000)

         SSE.close()

         accessibility()

         window.dataStoreHP.SSEstatus = 'disconnected'
      })
   }

} catch (error) {
   console.error('SG1.js', error)
   SG1Logs.incLog('Err_PORCH')
   SG1Logs.sentryEvent({ error: error, name: 'Page Orchestrator' })
}
